import { render, staticRenderFns } from "./FamilyMembersTableModal.vue?vue&type=template&id=44bd3b7a"
import script from "./FamilyMembersTableModal.vue?vue&type=script&lang=js"
export * from "./FamilyMembersTableModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports